export default "__VITE_ASSET__VoTDtHpM__"